export default __webpack_public_path__ + "static/media/wh2_main_great_vortex_map.b4a3926a.webp";